import { combineReducers } from 'redux';
import NotificationStore from '../Notification/reducers';
import UserStore from '../User/reducers';
import {SubcontractorStore} from '../Subcontractors/reducers';
import RoomStore from '../Rooms/reducers';
import { componentReducer } from '../components/reducers';
import { authReducer } from '../Auth/reducer';
import BuilderStore from '../Builders/reducers';
import TradeStore from '../Trades/reducers';
import ItemRepairStore from '../Items/reducers';
import LotStore from '../Lots/reducers';
import SearchStore from '../Search/reducers';
import WorkOrderStore from '../Work-Orders/reducers';
import CustomorderStore from '../DefaultConfig/reducers'

const rootReducer = combineReducers({
  UserStore,
  NotificationStore,
  SubcontractorStore,
  RoomStore,
  componentReducer,
  authReducer,
  BuilderStore,
  TradeStore,
  ItemRepairStore,
  LotStore,
  SearchStore,
  WorkOrderStore,
  CustomorderStore
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/portal_system/reducer.js